exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "a[data-v-20ab745f]{font-weight:600}.secondary[data-v-20ab745f]{margin:.2rem 0 .5rem;font-size:.8em;color:#666}.secondary .small-details[data-v-20ab745f]{font-size:.9em;margin-top:.7em;line-height:1.6em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-20ab745f","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?indentedSyntax!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/user/blocks/RequestMini.vue
// module id = 489
// module chunks = 0